import { AuthPartialStoreState } from '../auth.reducer';

export const getIsCookiesAccepted = (state: AuthPartialStoreState) => state.auth.customer.isCookiesAccepted;

export const getData = (state: AuthPartialStoreState) => state.auth.customer.data;
